import React, { useRef, useState } from 'react'
import { BsStar, BsStarFill } from 'react-icons/bs'
import Project from 'common/project'
import _data from 'common/utils/_data'

export const Feedback = ({ legalDocumentId }: { legalDocumentId: string }) => {
  const [rating, setRating] = useState<number>(-1)
  const [showDetailBox, setShowDetailBox] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<boolean>(false)
  const detailRef = useRef<HTMLTextAreaElement>(null)

  const handlePost = async () => {
    setLoading(true)
    setError(null)
    setSuccess(false)

    if (!detailRef.current) {
      return
    }

    if (rating < 0 || rating > 5) {
      setError('Please provide a valid rating.')
      return
    }

    if (!detailRef.current.value.trim()) {
      setError('Please provide a review message.')
      return
    }

    await _data
      .post(`${Project.liveApi}documents/ratings/`, {
        legaldocument: legalDocumentId,
        rating: rating + 1,
        review: detailRef.current.value,
      })
      .then(() => {
        setSuccess(true)
      })
      .catch((error) => {
        console.error('Error in submitting feedback:', error)
        setError(
          'There was an error submitting your feedback. Please try again.',
        )
      })
      .finally(() => {
        setLoading(false)
        detailRef.current.value = ''
      })
  }

  const handleRating = (index: number) => {
    setRating(index)
    setShowDetailBox(true)
  }

  return (
    <div className={`flex flex-col gap-[30px] items-center`}>
      <div className='flex flex-col justify-center items-center px-[30px] gap-6 text-[#122d5c]'>
        <h3 className='text-sm lg:text-2xl font-medium lg:font-bold leading-relaxed tracking-wide'>
          How helpful was this page?
        </h3>
        <div className='flex flex-col items-center w-full gap-2'>
          <div className='flex justify-start items-start gap-3'>
            {Array.from({ length: 5 }, (_, index) => (
              <span key={index} onClick={() => handleRating(index)}>
                {index <= rating ? (
                  <BsStarFill className='w-[16px] h-[16px] lg:w-6 lg:h-6 text-[#093269]' />
                ) : (
                  <BsStar className='w-[16px] h-[16px] lg:w-6 lg:h-6 text-[#093269]' />
                )}
              </span>
            ))}
          </div>
          <div className='flex justify-between gap-[40px] lg:gap-[64px] text-[10px] lg:text-sm font-normal lg:font-medium'>
            <span className=''>Not helpful</span>
            <span className=''>Very helpful</span>
          </div>
        </div>
      </div>
      {showDetailBox && (
        <div className='w-full max-w-[280px] lg:max-w-[368px] flex flex-col justify-center gap-5'>
          <div className='flex flex-col gap-2'>
            <label className='text-center text-[#122d5c] text-sm lg:text-lg font-medium lg:font-bold leading-normal tracking-wide'>
              How was your overall experience?
            </label>
            <textarea
              ref={detailRef}
              placeholder='Enter your description...'
              className='h-[132px] bg-white rounded-lg 
                shadow-[0px_0.5px_2px_0px_rgba(0,0,0,0.25)] lg:shadow-[inset_0px_1.2000000476837158px_4px_0px_rgba(0,0,0,0.15)] 
                text-[#00323D] border border-[#b2eaf8] text-xs lg:text-base resize-none'
              rows={6}
            />
          </div>
          {error && <div className='text-red-500 text-sm'>{error}</div>}
          {success && (
            <div className='text-green-500 text-sm'>
              Feedback submitted successfully!
            </div>
          )}
          <div className='flex justify-end'>
            <button
              onClick={handlePost}
              className="px-[8px] py-[6px] bg-[#FFFFFF] text-[#1c7d92] text-center rounded shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)] text-xs font-medium font-['DM Sans'] leading-none tracking-wide"
              disabled={loading}
            >
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
